import { type ChangeEvent, type FormEvent } from 'react'
import debounce from 'lodash/debounce'
import { executeRetrieveRecurringPaymentsSearch } from '../../../../../../../../shared/apiUtils/executeRetrieveRecurringPaymentsSearch'
import { recurringPaymentsProxy } from '../../../../recurringPaymentsProxy'

const handleFetch = async (): Promise<void> => { await executeRetrieveRecurringPaymentsSearch({ displayLoader: false }) }
export const debouncedHandleFetch = debounce(handleFetch, 100)

export function handleUpdate (e: ChangeEvent<HTMLInputElement>): void {
  recurringPaymentsProxy.filters.search = e.target.value
  void debouncedHandleFetch()
}

export const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
  e.preventDefault()
  void executeRetrieveRecurringPaymentsSearch({ displayLoader: false })
}
